import { Route, Routes, Navigate } from "react-router-dom";
import { Layout } from "./components/Layout.js";
import { Dashboard } from "./routes/Dashboard.js";
import { AccruedVacation } from "./routes/AccruedVacation.js";
import { FixedAssets } from "./routes/FixedAssets.js";
import { Intercompany } from "./routes/Intercompany.js";
import { Inventory } from "./routes/Inventory.js";
import { LeaseRou } from "./routes/LeaseRou.js";
import { PoAccrual } from "./routes/PoAccrual.js";
import { Sources } from "./routes/Sources.js";

export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/close/2026-01" replace />} />
        <Route path="/close/:period" element={<Dashboard />} />
        <Route path="/close/:period/sources" element={<Sources />} />
        <Route
          path="/close/:period/recons/po-accrual"
          element={<PoAccrual />}
        />
        <Route
          path="/close/:period/recons/accrued-vacation"
          element={<AccruedVacation />}
        />
        <Route
          path="/close/:period/recons/inventory"
          element={<Inventory />}
        />
        <Route
          path="/close/:period/recons/fixed-assets"
          element={<FixedAssets />}
        />
        <Route
          path="/close/:period/recons/lease-rou"
          element={<LeaseRou />}
        />
        <Route
          path="/close/:period/recons/intercompany-cervos"
          element={<Intercompany />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function NotFound() {
  return <div className="card">Not found.</div>;
}
